import 'reflect-metadata';
export function injectable() {
    return function (target) {
        var types = Reflect.getMetadata('design:paramtypes', target) || [];
        Reflect.defineMetadata('inversify:paramtypes', types, target);
        return target;
    };
}
